import type { Language } from '../../i18n/translations.js';
import { DEMO_COPY } from './demo-copy.js';
export function ProjectReadiness({ language }: { readonly language: Language }) {
  const c = DEMO_COPY[language];
  return (
    <section
      className="wrap readiness roadmap"
      id="readiness"
      aria-labelledby="readiness-title"
    >
      <div className="roadmap-heading">
        <p className="eyebrow">
          <i className="signal" aria-hidden="true"></i>
          <span>{c.projectRoadmap}</span>
        </p>
        <h2 id="readiness-title">
          <span>{c.buildingMouja}</span>
          <br />
          <span>{c.withCpmai}</span>
        </h2>
        <p className="roadmap-intro">{c.ourProjectFollowsCpmaiWeRevisit}</p>
      </div>
      <ol className="roadmap-milestones" aria-label={c.cpmaiPhasesCoveredSoFar}>
        <li className="roadmap-milestone is-tested">
          <span className="roadmap-status">{c.covered}</span>
          <div className="roadmap-track" aria-hidden="true">
            <span className="roadmap-node">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
              >
                <path d="m7 12 3 3 7-7"></path>
              </svg>
            </span>
          </div>
          <div className="roadmap-content">
            <span className="roadmap-index" aria-hidden="true">
              {'01'}
            </span>
            <h3>{c.businessUnderstanding}</h3>
            <p>{c.definingTheBusinessObjective}</p>
          </div>
        </li>
        <li className="roadmap-milestone is-tested">
          <span className="roadmap-status">{c.covered}</span>
          <div className="roadmap-track" aria-hidden="true">
            <span className="roadmap-node">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
              >
                <path d="m7 12 3 3 7-7"></path>
              </svg>
            </span>
          </div>
          <div className="roadmap-content">
            <span className="roadmap-index" aria-hidden="true">
              {'02'}
            </span>
            <h3>{c.dataUnderstanding}</h3>
            <p>{c.understandingVideosAndCustomerAssets}</p>
          </div>
        </li>
        <li className="roadmap-milestone is-current" aria-current="step">
          <span className="roadmap-status">
            <i aria-hidden="true"></i>
            <span>{c.currentPhase}</span>
          </span>
          <div className="roadmap-track" aria-hidden="true">
            <span className="roadmap-node">
              <span></span>
            </span>
          </div>
          <div className="roadmap-content">
            <span className="roadmap-index" aria-hidden="true">
              {'03'}
            </span>
            <h3>{c.dataPreparation}</h3>
            <p>{c.organizingVideosRequiredAssetsAndTested}</p>
          </div>
        </li>
      </ol>
      <div className="roadmap-footnote">
        <span className="roadmap-focus-mark" aria-hidden="true"></span>
        <p className="methodology" dir="ltr" lang="en">
          {'Current focus: CPMAI — Data Preparation.'}
        </p>
      </div>
    </section>
  );
}
